<script setup lang="ts">
import type { ComboboxItemEmits, ComboboxItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ComboboxItem, useForwardPropsEmits } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<ComboboxItemProps & { class?: HTMLAttributes['class'] }>();
const emits = defineEmits<ComboboxItemEmits>();

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <ComboboxItem
    v-bind="forwarded"
    :class="
      cn(
        'tw-relative tw-flex tw-cursor-default tw-gap-2 tw-select-none tw-justify-between tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none data-[highlighted]:tw-bg-neutral-100 data-[highlighted]:tw-text-neutral-900 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 dark:data-[highlighted]:tw-bg-neutral-800 dark:data-[highlighted]:tw-text-neutral-50',
        props.class
      )
    "
  >
    <slot />
  </ComboboxItem>
</template>
